import {AnalyticsProvider} from '@github-ui/analytics-provider'
import {isLoggedIn} from '@github-ui/client-env'
import {RecentlyTouchedBranchesProvider} from '@github-ui/code-view-shared/contexts/RecentlyTouchedBranchesContext'
import {RecentlyTouchedBranches as RecentlyTouchedBranchesBanner} from '@github-ui/repos-overview/components/header/RecentlyTouchedBranches'
import {CollapsibleSidebar} from '@github-ui/layout-primitives/CollapsibleSidebar'
import {SidebarPageLayout} from '@github-ui/layout-primitives/SidebarPageLayout'
import {PreviewCardOutlet} from '@github-ui/preview-card'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {Outlet} from '@github-ui/react-router'

import {repoPullsDashboardRepositoryToRepository} from '../helpers/repo-pulls-dashboard-proto'
import {RepoStacksHeader} from '../components/stacks/RepoStacksHeader'
import {useIsRepoStacksPage} from '../components/stacks/use-is-repo-stacks-page'
import {
  RepoPullsDashboardCollapsibleSidebar,
  RepoPullsDashboardFeedback,
  RepoPullsDashboardHeader,
} from './RepoPullsDashboardHeader'
import {repoPullsDashboardLayoutRoute} from './repo-pulls-dashboard-layout-route'

export function RepoPullsDashboardLayout() {
  const showSidebar = isLoggedIn()
  const isStacksPage = useIsRepoStacksPage()
  const {data: layoutPayload} = useRouteQuery(repoPullsDashboardLayoutRoute, 'mainQuery')

  return (
    <AnalyticsProvider
      appName="repo-pulls-dashboard-surface"
      category="Repository Pull Requests"
      metadata={{page: 'repo-pulls-dashboard'}}
    >
      <div data-issue-and-pr-hovercards-enabled>
        <SidebarPageLayout storageKey="pulls-dashboard-sidebar" initialExpanded={layoutPayload?.sidebarExpanded}>
          <SidebarPageLayout.Header>
            {isStacksPage ? (
              <RepoStacksHeader showSidebar={showSidebar} />
            ) : (
              <>
                <RepoPullsDashboardRecentlyTouchedBranches />
                <RepoPullsDashboardHeader showSidebar={showSidebar} />
              </>
            )}
          </SidebarPageLayout.Header>
          {showSidebar && (
            <SidebarPageLayout.Sidebar
              aria-label="Pull requests navigation"
              dialogTitle="Pull requests"
              footer={
                <>
                  <RepoPullsDashboardFeedback />
                  <CollapsibleSidebar.Toggle />
                </>
              }
            >
              <RepoPullsDashboardCollapsibleSidebar />
            </SidebarPageLayout.Sidebar>
          )}
          <SidebarPageLayout.Content as="div">
            <Outlet />
          </SidebarPageLayout.Content>
        </SidebarPageLayout>
        <PreviewCardOutlet />
      </div>
    </AnalyticsProvider>
  )
}

function RepoPullsDashboardRecentlyTouchedBranches() {
  const {data: layoutPayload} = useRouteQuery(repoPullsDashboardLayoutRoute, 'mainQuery')
  const {data: recentlyTouchedBranches, refetch} = useRouteQuery(
    repoPullsDashboardLayoutRoute,
    'recentlyTouchedBranches',
  )

  if (!layoutPayload?.repository || !recentlyTouchedBranches?.channel || !recentlyTouchedBranches.branches?.length) {
    return null
  }

  return (
    <div className="d-flex flex-column gap-2 tmp-mb-3" data-testid="repo-pulls-recently-touched-branches">
      <RecentlyTouchedBranchesProvider
        branches={recentlyTouchedBranches?.branches}
        channel={recentlyTouchedBranches?.channel}
        canCreatePullRequest={recentlyTouchedBranches?.canCreatePullRequest}
        refetch={refetch}
      >
        <RecentlyTouchedBranchesBanner repo={repoPullsDashboardRepositoryToRepository(layoutPayload.repository)} />
      </RecentlyTouchedBranchesProvider>
    </div>
  )
}
